import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeStripeNative } from "@/lib/stripeNative";

// Initialize native Stripe SDK for Capacitor (Google Pay / Apple Pay)
initializeStripeNative();

createRoot(document.getElementById("root")!).render(<App />);
